<template>
  <v-card outlined>
    <v-img
      :src="item.data.image.url"
      :alt="item.data.image.alt"
      height="150"
    >
    <div class="d-flex justify-end fill-height">
      <div class="d-flex flex-column justify-space-between align-end fill-height pa-3">
        <div>
          <div v-if="
            item.data.restricted_to_membership_enum &&
            item.data.restricted_to_membership_enum.uid
          ">
            <v-btn v-if="item.data.restricted_to_membership_enum.uid === types.subscription.type.pro.toLowerCase()" x-small depressed color="gold">
              Pro & Pro+ only
            </v-btn>
            <v-btn v-else x-small depressed color="gold">
              Pro+ only
            </v-btn>
          </div>
        </div>
        <div>
          <div v-if="
            item.data.stock &&
            item.data.stock > 0
          ">
            <v-btn v-if="stock[item.data.reward_enum.uid].available > 0" x-small depressed color="success">
              {{ stock[item.data.reward_enum.uid].available }} in stock
            </v-btn>
            <v-btn v-else x-small depressed color="error">
              Out of Stock
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-img>
    <v-card-text>
      <h2 class="text-title">{{ item.data.title[0].text }}</h2>
      <h3 class="text-caption">
        Valid until: {{ item.data.valid_until ? item.data.valid_until : 'TBD' }}
      </h3>
      <h4 class="text-body-1 font-weight-bold mt-2">
        Price: <v-icon small class="gold--text mr-1">fal fa-cubes</v-icon
        >{{ item.data.price }}
      </h4>
      <v-dialog v-model="howDoDialog" width="500">
        <template #activator="{ on }">
          <h5 class="text-display6 mt-2 pointer d-flex align-center" v-on="on">
            <v-icon x-small class="mr-1">fal fa-info-circle</v-icon>Reward information
          </h5>
        </template>
        <v-card outlined>
          <v-card-title class="text-h5" primary-title>
            {{ item.data.title[0].text }}
          </v-card-title>
          <v-card-text>
            <prismic-rich-text :field="item.data.information" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small @click="howDoDialog = false"> Close </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        depressed
        block
        color="success"
        class="mt-3"
        @click="redeemItem(item.data.reward_enum.uid, item.data.price)"
      >
        Redeem
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import types from '@/utils/types'

export default {
  name: 'RewardsCard',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    stock: {
      type: Object,
      default: () => {}
    },
    redeemItem: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      types,
      howDoDialog: false
    }
  }
}
</script>
